import store from '@/store';
import TeamQueries from '@/queries/team.queries';
import ApiService from './ApiService';
import UtilsService from './UtilsService';

function getAllTeams() {
  return ApiService.get(UtilsService.buildFullPath(TeamQueries.getAll(
    store.state.auth.currentUser.retailer.objectId,
  ))).then((res) => res.results);
}

const TeamService = {
  getAllTeams,
};

export default TeamService;
